module.exports = __webpack_public_path__ + "media/images/attachement-preview-cae7d99454da4a17519be22d66498e6d.jpg";